module.exports = __webpack_public_path__ + "img/M_Read_more_compare_female.242f567b.svg";